/**
 * CompleteReason.ts
 */
export class CompleteReason {
    constructor(id) {
        this.id = id;
    }
    static getReason(id) {
        return CompleteReason[id];
    }
    getId() {
        return this.id;
    }
    isTicketMatched() {
        return this === CompleteReason.TICKET_MATCHED;
    }
    isNoPurchaseSpin() {
        return this === CompleteReason.NO_PURCHASE_SPIN;
    }
    isNoPurchaseStake() {
        return this === CompleteReason.NO_PURCHASE_STAKE;
    }
    isMinimumStakeLimit() {
        return this === CompleteReason.MINIMUM_STAKE_LIMIT;
    }
    isMaximumStakeLimit() {
        return this === CompleteReason.MAXIMUM_STAKE_LIMIT;
    }
    isMaximumTotalStakeLimit() {
        return this === CompleteReason.MAXIMUM_TOTAL_STAKE_LIMIT;
    }
}
CompleteReason.TICKET_MATCHED = new CompleteReason("TICKET_MATCHED");
CompleteReason.NO_PURCHASE_SPIN = new CompleteReason("NO_PURCHASE_SPIN");
CompleteReason.NO_PURCHASE_STAKE = new CompleteReason("NO_PURCHASE_STAKE");
CompleteReason.MINIMUM_STAKE_LIMIT = new CompleteReason("MINIMUM_STAKE_LIMIT");
CompleteReason.MAXIMUM_STAKE_LIMIT = new CompleteReason("MAXIMUM_STAKE_LIMIT");
CompleteReason.MAXIMUM_TOTAL_STAKE_LIMIT = new CompleteReason("MAXIMUM_TOTAL_STAKE_LIMIT");
//# sourceMappingURL=CompleteReason.js.map